import request from "../utils/request.js";
import qs from 'qs';
export function getConversationList(queryParams) {
  return request({
    url: `/conversation/list`,
    method: 'GET',
    params: queryParams,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  });
}
export function retryAIReview(conversationId, userId) {
  return request({
    url: `/conversation/retryAireview/${conversationId}/${userId}`,
    method: 'GET',
  });
}
export function getConversationAiReview(conversationId) {
  return request({
    url: `/conversation/aiReview/${conversationId}`,
    method: 'GET'
  });
}
export function getUserInfo(userId) {
  return request({
    url: `/users/${userId}`,
    method: 'GET',
  });
}

export function getConversationInfo(userId, conversationRef) {
  return request({
    url: `/conversation/message/${userId}/${conversationRef}`,
    method: 'GET',
  });
}

export function getConversation(conversationRef) {
  return request({
    url: `/conversation/${conversationRef}`,
    method: 'GET',
  });
}

export function getOptimusBrand(isRefresh) {
  return request({
    url: `/callOptimus/getOptimusBrands/${isRefresh}`,
    method: 'GET',
  });
}

export function addOptimusInspection(data) {

  return request({
    url: `/callOptimus/addOptimusInspection`,
    method: 'POST',
    data: data,
  });
}

export function getPartner(companyId) {
  return request({
    url: `/conversation/partnerId/${companyId}`,
    method: 'GET',
  });
}

export function getSocialMediaPlatforms() {
  return request({
    url: `/conversation/social-media-platforms`,
    method: 'GET',
  });
}

export function getPartnerBrands(companyId) {
  return request({
    url: `/company/partnerBrand/${companyId}`,
    method: 'GET',
  });
}
